import { render, staticRenderFns } from "./PageDataDesc.vue?vue&type=template&id=2a11a013&scoped=true&"
import script from "./PageDataDesc.vue?vue&type=script&lang=js&"
export * from "./PageDataDesc.vue?vue&type=script&lang=js&"
import style0 from "./PageDataDesc.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PageDataDesc.vue?vue&type=style&index=1&id=2a11a013&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a11a013",
  null
  
)

export default component.exports